import { useRandomWordsData, useVrfEvents, useWorker } from '@/hooks'
import { useCallback, useEffect, useState } from 'react'

const fetchData = async ({
  fetchHistoryData,
  setAllRequests,
  setAllEvents,
}) => {
  const { requests, events } = await fetchHistoryData()

  setAllRequests(requests)
  setAllEvents(events)
}

export const useHistory = ({ subId }) => {
  const { historyWorker } = useWorker()
  const [allRequests, setAllRequests] = useState()
  const [allEvents, setAllEvents] = useState()
  const [isLoadingRequests, setIsLoadingRequests] = useState(true)
  const [isLoadingEvents, setIsLoadingEvents] = useState(true)
  const { getAllRequests } = useRandomWordsData(subId)
  const { getAllEvents } = useVrfEvents(subId)

  const fetchHistoryData = useCallback(async () => {
    if (!historyWorker || !getAllRequests || !getAllEvents) {
      return
    }

    const { randomWordsRequested, randomWordsFulfilled } =
      await getAllRequests()
    const { events } = await getAllEvents()

    const history = await historyWorker.createHistory({
      requestedEvents: randomWordsRequested,
      fulfilledEvents: randomWordsFulfilled,
      events,
    })

    setIsLoadingRequests(false)
    setIsLoadingEvents(false)

    return history
  }, [historyWorker, getAllRequests, getAllEvents])

  useEffect(() => {
    if (!subId) {
      return
    }

    fetchData({ setAllEvents, setAllRequests, fetchHistoryData })
  }, [subId])

  return {
    requests: allRequests,
    isLoadingRequests,
    events: allEvents,
    isLoadingEvents,
  }
}
